<template>
  <div class="collection-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <i class="icon-star"></i><span>我的收藏</span>
      <div class="collection-count">共 <span class="count">{{ total }}</span> 件藏品</div>
    </div>

    <!-- 收藏列表 -->
    <div class="collection-grid">
      <!-- 循环渲染分页后的收藏项 -->
      <div class="model-card" v-for="item in collections" :key="item.modelId" @click="goToDetail(item.modelId)">
        <img :src="item.previewUrl" :alt="item.title" class="model-img">
        <div class="model-info">
          <div class="model-name">{{ item.title }}</div>

          <div class="model-meta">
            <div class="meta-item">
              <span>{{ item.licensingPrices }}云币</span>
            </div>
            <div class="meta-item">
              <i class="el-icon-view"></i>
              <span>{{ item.clickThrough }}次浏览</span>
            </div>
            <div class="meta-item">
              <i class="el-icon-bottom"></i>
              <span>{{ item.downloadVolume }}次下载</span>
            </div>
          </div>

          <div class="model-author">
            <img :src="item.userAvatar" :alt="item.userName" class="author-avatar">
            <span class="author-name">{{ item.userName }}</span>
            <button class="collect-btn active" @click.stop="toggleCollect(item.modelId)">
              <i class="icon-collected"></i>
              已收藏
            </button>
          </div>

          <div class="model-tags">
            <span class="tag" v-for="tag in item.tags" :key="tag">{{ tag }}</span>
          </div>
        </div>
      </div>

      <!-- 空数据提示 -->
      <div class="empty-collection" v-if="total === 0">
        <i class="icon-empty"></i>
        <p>暂无收藏内容</p>
        <button class="back-btn" @click="goHome">去首页逛逛</button>
      </div>
    </div>

    <!-- 分页组件 - 与参考代码样式保持一致 -->
    <div class="pagination-container" v-if="total > 0">
      <el-pagination @current-change="handleCurrentChange" :current-page="pageIndex" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionPage',
  data() {
    return {
      token: localStorage.getItem('token'),
      // 收藏模型列表数据（分页后的数据）
      collections: [],
      // 分页相关参数 - 与参考代码保持一致
      pageIndex: 1,       // 当前页码，默认第一页
      pageSize: 10,       // 每页条数，设置为10条
      total: 0            // 总数据条数
    };
  },
  mounted() {
    this.getMyCollection()
  },
  methods: {
    goToDetail(modelId) {
      const routeInfo = this.$router.resolve({
        path: '/detail',
        query: {
          id: modelId
        }
      });
      window.open(routeInfo.href, '_blank');
    },

    // 获取我的收藏 - 添加分页参数
    getMyCollection() {
      // 构造接口请求参数（添加分页参数）
      const requestParams = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };

      this.$apiFun.getMyCollection(requestParams)
        .then(res => {
          if (res.status === 200) {
            this.collections = res.obj || [];      // 当前页数据
            this.total = res.num || 0;             // 总条数（从res.num获取）
            console.log('收藏数据加载成功:', this.collections, '总条数:', this.total);
          }
        })
        .catch(err => {
          console.error('我的收藏获取失败:', err);
          this.collections = [];
          this.total = 0;
        });
    },

    // 切换收藏状态
    async toggleCollect(id) {
      // 实际项目中需调用接口处理取消收藏逻辑
      if (this.token) {
        try {
          const res = await this.$apiFun.getAddMyCollection({
            modelId: id,
          });
          if (res.status === 200) {
            // 从当前列表中移除该项
            this.collections = this.collections.filter(item => item.modelId !== id);
            // 更新总条数
            this.total = Math.max(0, this.total - 1);
            this.$message.success(`已取消收藏 ID: ${id}`);

            // 如果删除后当前页无数据且不是第一页，自动跳转到上一页
            if (this.collections.length === 0 && this.pageIndex > 1) {
              this.pageIndex -= 1;
              this.getMyCollection();
            }
          } else if (res.status === 401 || res.status === 0) {
            this.$message.warning(res.msg);
            this.$router.push('/login');
            return;
          } else {
            this.$message.error(`取消收藏失败：${res.message || '未知错误'}`);
          }
        } catch (err) {
          console.error('收藏操作失败：', err);
          this.$message.error('网络异常，请稍后重试');
        }
      } else {
        this.$message.warning('请先登录后再进行收藏操作');
        localStorage.removeItem('userData');
        localStorage.removeItem('token');
        this.$router.push('/login');
        return;
      }
    },

    // 返回首页
    goHome() {
      this.$router.push('/');
    },

    // 分页 - 当前页码改变（与参考代码保持一致）
    handleCurrentChange(val) {
      this.pageIndex = val; // 更新当前页码
      this.getMyCollection();    // 重新请求数据
    }
  }
};
</script>

<style lang="less" scoped>
// 深色主题变量
@bg-primary: #2c2c2c;
@bg-secondary: #3a3a3a;
@bg-tertiary: #454545;
@text-primary: #e0e0e0;
@text-secondary: #a0a0a0;
@accent-red: #0ea5e9;
@border-color: #444;
@tag-bg: #4a5a6a;
@hover-bg: rgba(255, 255, 255, 0.1);

.collection-page {
  color: @text-primary;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;

  // 页面标题
  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid @border-color;

    .icon-star {
      width: 24px;
      height: 24px;
      margin-right: 10px;
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="%23ff4d4f" d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.4-14.4-15.4-7.8-32.2-11.7-49.3-11.7s-33.9 3.9-49.3 11.7c-6.2 3-11.3 8.1-14.4 14.4L369.8 316.2 115.9 353.1c-14.9 2.1-27.5 12.2-32.1 26.7-3 8.7-.6 18.4 6.6 24.6l183.7 179.1-43.4 252.9c-2.4 14 5.8 27.3 18.8 31.2 13.1 3.8 27.6-1.9 35.3-13.8L512 754l227.1 119.4c7.8 4.1 14.5 4.1 22.3 0 13-5.9 21.2-17.2 18.8-31.2l-43.4-252.9 183.7-179.1c7.2-6.2 9.6-15.9 6.6-24.6 4.6-14.5-17.2-24.6-32-26.7z"/></svg>') no-repeat center;
    }

    span {
      font-size: 20px;
      font-weight: 500;
    }

    .collection-count {
      color: @text-secondary;
      font-size: 14px;

      .count {
        color: @accent-red;
        font-weight: 500;
        margin: 0 5px;
      }
    }
  }

  // 收藏网格布局
  .collection-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 40px;
  }

  // 空数据提示
  .empty-collection {
    grid-column: 1 / -1; // 跨列显示
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: @text-secondary;
    text-align: center;

    .icon-empty {
      width: 80px;
      height: 80px;
      margin-bottom: 20px;
      background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="%23666" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"/></svg>') no-repeat center;
      opacity: 0.3;
    }

    p {
      font-size: 16px;
      margin-bottom: 30px;
    }

    .back-btn {
      background-color: @accent-red;
      color: #fff;
      border: none;
      padding: 10px 20px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.2s;

      &:hover {
        background-color: #0b8bcd;
      }
    }
  }

  // 模型卡片样式
  .model-card {
    // background-color: @bg-secondary;
    border-radius: 6px;
    overflow: hidden;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    }

    .model-img {
      width: 100%;
      height: 200px;
      object-fit: cover;
      display: block;
    }

    .model-info {
      padding: 15px;
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .model-name {
      font-size: 16px;
      margin-bottom: 12px;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      min-height: 45px; // 确保高度一致
    }

    .model-meta {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      font-size: 13px;

      .meta-item {
        display: flex;
        align-items: center;
        color: @text-secondary;

        i {
          width: 16px;
          height: 16px;
          margin-right: 5px;
          display: inline-block;
        }

        .icon-type {
          background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="%23a0a0a0" d="M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768zm0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896z"/></svg>') no-repeat center;
        }

        .icon-eye {
          background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="%23a0a0a0" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"/></svg>') no-repeat center;
        }

        .icon-download {
          background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="%23a0a0a0" d="M512 832c-23.3 0-42.1-18.8-42.1-42.1s18.8-42.1 42.1-42.1 42.1 18.8 42.1 42.1-18.8 42.1-42.1 42.1zm286.1-357.3l-94.3-91.9c-10.1-9.8-27.4-9.8-37.5 0l-94.3 91.9V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v346.7L257.3 474.7c-10.1-9.8-27.4-9.8-37.5 0-10.1 9.8-10.1 25.8 0 35.6l144 141c5.1 5 11.8 7.8 18.8 7.8s13.7-2.8 18.8-7.8l144-141c10.1-9.8 10.1-25.8 0-35.6z"/></svg>') no-repeat center;
        }
      }
    }

    .model-author {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      padding-bottom: 12px;
      border-bottom: 1px dashed @border-color;

      .author-avatar {
        width: 36px;
        height: 36px;
        object-fit: cover;
        border-radius: 10%;
        background-color: @bg-tertiary;
        margin-right: 10px;
      }

      .author-name {
        font-size: 14px;
        color: @text-primary;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .collect-btn {
        display: flex;
        align-items: center;
        background-color: @accent-red;
        color: #fff;
        border: none;
        padding: 6px 12px;
        border-radius: 4px;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.2s;

        i {
          width: 16px;
          height: 16px;
          margin-right: 5px;
          display: inline-block;
        }

        .icon-collected {
          background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="%23ffffff" d="M355.7 136.9c67.3-69.4 163.7-106.9 256.3-106.9 189.6 0 267.6 156.9 267.6 267.6 0 92.6-37.5 189-106.9 256.3L512 819.5 163.7 560.8c-69.4-67.3-106.9-163.7-106.9-256.3 0-110.7 87.9-267.6 267.6-267.6 92.6 0 189 37.5 256.3 106.9L512 213.5l-156.3-76.6z"/></svg>') no-repeat center;
        }

        &.active {
          background-color: @bg-tertiary;
          color: @text-secondary;
          cursor: default;
        }
      }
    }

    .model-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin-top: auto;

      .tag {
        background-color: @tag-bg;
        color: @text-secondary;
        font-size: 12px;
        padding: 3px 8px;
        border-radius: 3px;
      }
    }
  }

  // 分页组件样式 - 完全复用参考代码的样式
  .pagination-container {
    margin-top: 30px; // 增加间距，视觉更友好
    display: flex;
    justify-content: center; // 水平居中核心
    align-items: center; // 垂直居中，避免错位
    padding: 10px 0;
  }

  // 核心：修改分页组件的背景色、字体色，与参考代码保持一致
  :deep(.el-pagination) {
    // 1. 分页组件整体背景色（如果需要）
    background-color: transparent !important; // 透明，继承页面深色背景

    // 2. 总条数文字颜色
    .el-pagination__total {
      color: #e0e0e0 !important; // 浅色文字，适配深色背景
      font-size: 14px !important; // 可选：调整字体大小
    }

    // 3. 页码按钮样式
    .el-pager {
      li {
        // 未选中页码的样式
        background-color: #080a12 !important; // 深色背景
        color: #a0a0a0 !important; // 次要文字色
        border: 1px solid #424242 !important; // 边框色
        margin: 0 2px !important; // 页码间距

        // 页码 hover 效果
        &:hover {
          background-color: rgba(255, 255, 255, 0.1) !important;
          color: #0ea5e9 !important; // 高亮蓝色
          border-color: #0ea5e9 !important;
        }

        // 当前选中页码的样式
        &.active {
          background-color: #0ea5e9 !important; // 主色背景
          color: #ffffff !important; // 白色文字
          border-color: #0ea5e9 !important;
        }
      }
    }

    // 4. 上一页/下一页按钮样式
    .btn-prev,
    .btn-next {
      background-color: @bg-secondary !important;
      color: @text-secondary !important;
      border: 1px solid @border-color !important;
      min-width: 30px !important;
      margin: 0 2px !important;

      // 禁用状态
      &.disabled {
        background-color: darken(@bg-secondary, 5%) !important;
        color: darken(@text-secondary, 20%) !important;
        border-color: darken(@border-color, 10%) !important;
        cursor: not-allowed !important;

        &:hover {
          background-color: darken(@bg-secondary, 5%) !important;
          color: darken(@text-secondary, 20%) !important;
          border-color: darken(@border-color, 10%) !important;
        }
      }

      // 正常状态 hover
      &:not(.disabled):hover {
        background-color: @hover-bg !important;
        color: @accent-red !important;
        border-color: @accent-red !important;
      }

      // 图标样式
      .el-icon {
        font-size: 12px !important;
        font-weight: bold !important;
      }
    }

    // 5. 跳转页码输入框样式
    .el-pagination__jump {
      color: #a0a0a0 !important; // 文字色

      .el-input__inner {
        background-color: #080a12 !important; // 输入框背景
        color: #e0e0e0 !important; // 输入框文字色
        border: 1px solid #424242 !important; // 输入框边框

        &:focus {
          border-color: #0ea5e9 !important; // 聚焦边框色
        }
      }
    }
  }
}

// 响应式适配 - 复用参考代码的响应式样式
@media (max-width: 768px) {
  .collection-page {
    padding: 10px;

    // 分页组件响应式
    .pagination-container {
      :deep(.el-pagination) {
        justify-content: center;
        flex-wrap: wrap;

        .btn-prev,
        .btn-next {
          margin: 2px !important;
        }

        .el-pager li {
          margin: 2px !important;
        }
      }
    }
  }
}
</style>